module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-47.ee48f504.png";